import { useParams } from "react-router-dom";
import routing from "routing";

import ArticlesSearch from "./ArticlesSearch";
import { DecksSearch } from "./DecksSearch";
import { ExamsSearch } from "./ExamsSearch";

export default function Search() {
	const params = useParams();
	if (params.type === routing.searchTypes.questions) {
		return <ExamsSearch />;
	}

	if (params.type === routing.searchTypes.decks) {
		return <DecksSearch />;
	}

	return <ArticlesSearch />;
}
